<template>
  <div >
    <el-drawer @reload="$reloadHandle" :title="titleName" size="40%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                  </div>
                </div>
                <el-form-item v-if="type===1" label="反馈备注" label-width="100px">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" v-model="formData.replyMessage" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="type===2" label="完结备注" label-width="100px">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" v-model="formData.finishMessage" autocomplete="off"></el-input>
                </el-form-item>

                <div v-if="formData.requestSource==2" class="d-item">
                  <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                    <div class="title first"><b>附件列表</b></div>
                    <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                               :action="api.uploadFileUrl"  :show-file-list="false" :on-progress="upVideo"
                               :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                               :auto-upload="true">
                      <el-button type="primary" class="button-sty btn_zdy">
                        <i class="el-icon-plus"></i>
                        附件
                      </el-button>
                    </el-upload>
                  </div>
                  <div>
                    <vxe-table style="margin-top: 0px;" :stripe="true"
                               :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                               :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                               show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                               @checkbox-all="selectChangeEvent" :data="fileList">
                      <vxe-column type="checkbox" width="40" />
                      <vxe-column field="fileName" title="附件名称" width="400">
                        <template #default="{ row }">
                          <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a>
                        </template>
                      </vxe-column>
                      <vxe-column title="操作" width="60">
                        <template #default="{ row }">
                          <div @click="deleteFile(row)">
                            <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                        popper-class="tooltip-skin">
                              <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                            </el-tooltip>
                          </div>
                        </template>
                      </vxe-column>
                    </vxe-table>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="commitOrder">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
import store from "@/store";
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['multi','type','orderId','requestSource' ],
    components: {
    },
    created(){
      this.formData.id  = this.orderId
      this.formData.requestSource = this.requestSource
    },
    computed: {

      api() {
        return api
      },
      headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId
        };
      }

    },
    data() {
      return {
        fileList: [],
        doUrl:"/basic/tmComplaintOrder/updateComplaintOrder",
        titleName:"一键求助跟进",
        comfirmNote:"",
        remark:"",
        show3: false,
        dataId: '',
        drawer: true,
        formData: {},
      }
    },
    mounted() {
    },
    methods: {
      upVideo() {
        this.$mask.open()

      },
      deleteFile(row) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          console.log(row, 'delete')
          this.fileList = this.fileList.filter(item => item.url !== row.url)
        })
      },
      selectChangeEvent(data) {
        console.log('选中数据', data)
        this.selectedData = data.records
      },
      handleFileSuccess(res, file, fileList) {
        let url = res.data.url
        let fileName = file.name
        console.log(url, "url")
        console.log(fileName, "name")
        this.fileList.push({
          fileName: fileName,
          fileUrl: url
        })
        this.$mask.close()

      },
      shut() {
        // this.showOrderPop=true
      },
      commitOrder() {
          let tipStr ="";
          if (this.type ==1){
            this.formData.type =1
            tipStr = "是否确认反馈天猫！";
            if (this.formData.replyMessage=="" || this.formData.replyMessage ==null){
              this.$message.error('请输入反馈备注！')
              return
            }
          }else if(this.type ==2){
            this.formData.type =2
            tipStr = "是否确认完结一键求助";
            if (this.formData.finishMessage=="" || this.formData.finishMessage == null){
              this.$message.error('请输入完结备注！')
              return
            }
          }
          if(this.fileList){
            this.formData.tmComplaintOrderFileDTOList = this.formData.tmComplaintOrderFileDTOList || []
            this.formData.tmComplaintOrderFileDTOList = this.fileList
          }
        this.$baseConfirm(tipStr).then(() => {
          request({
            url: this.doUrl,
            method: 'post',
            data: this.formData,
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            if (response.data.type == "success") {
              this.$message({message: response.data.content, type: 'success'});
              this.drawer = false;
              clearTimeout(this.timer);
              this.$emit('closeDialog', 1)
            } else {
              this.$message({message: response.data.content, type: 'warning'});
            }
          })
        })
      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
        this.$emit('closeDialog', 0)
      },
      handleClose() {

        this.drawer = false;
        this.$emit('closeDialog', 0)
      }
    }
  }
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
//   3个标签
.information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
//   每个分支
.d-item {
  border: 1px solid #ededed;
  padding-bottom: 5px;

  .title b {
    display: inline-block;
    line-height: 20px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: rgb(42, 100, 148);
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-bottom: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0px 28px 28px 0px;
}
.table-detail tr {
    margin-bottom: 10px;
    display: block;
th {
    font-weight: 400;
    text-align: right;
    width: 7vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 5px 0 4px;
    color: rgba(86, 86, 86, 0.96);
}
td {
    font-weight: 400;
    // text-align: right;
    width: 10vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 0px 0 4px;
    color: rgba(0, 0, 0,);
}
}}

::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
 ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
}
}
</style>
